import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { LineChart } from '@mui/x-charts/LineChart';
import type React from 'react';

interface CostsByMonthDataPoint {
  month: string;
  label: string;
  ai: number;
  floid: number;
  meta: number;
  total: number;
}

interface CostsLineChartProps {
  title: string;
  data: CostsByMonthDataPoint[];
  yAxisLabel?: string;
  height?: number;
}

const CostsLineChart: React.FC<CostsLineChartProps> = ({ title, data, yAxisLabel, height = 350 }) => {
  const theme = useTheme();

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
        <LineChart
          series={[
            {
              data: data.map((d) => d.total),
              label: 'Total',
              color: theme.palette.error.main,
              showMark: true,
            },
            {
              data: data.map((d) => d.ai),
              label: 'AI',
              color: theme.palette.primary.main,
              showMark: true,
            },
            {
              data: data.map((d) => d.floid),
              label: 'Floid',
              color: theme.palette.warning.main,
              showMark: true,
            },
            {
              data: data.map((d) => d.meta),
              label: 'Meta/WhatsApp',
              color: theme.palette.success.main,
              showMark: true,
            },
          ]}
          xAxis={[
            {
              data: data.map((d) => d.label),
              scaleType: 'point',
            },
          ]}
          height={height}
          margin={{ top: 60, bottom: 40, left: yAxisLabel ? 100 : 80, right: 50 }}
          yAxis={
            yAxisLabel
              ? [
                  {
                    label: yAxisLabel,
                  },
                ]
              : undefined
          }
          slotProps={{
            legend: {
              position: {
                vertical: 'top',
                horizontal: 'end',
              },
            },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default CostsLineChart;
